import { HiSparkles } from "react-icons/hi2";

export const AISummaryCard = ({ summary }) => (
  <div className="rounded-xl border border-gray-200 bg-white">
    <div className="flex items-center gap-2 border-b border-gray-200 px-5 py-4">
      <HiSparkles className="size-4 text-violet-500" />
      <h2 className="text-base font-semibold text-gray-900">AI Summary</h2>
    </div>
    <div className="px-5 py-4">
      <p className="text-sm leading-relaxed text-gray-800">{summary}</p>
    </div>
  </div>
);
